import { auth as enUS_auth } from './en-US/auth';
import { campanhas as enUS_campanhas } from './en-US/campanhas';
import { common as enUS_common } from './en-US/common';
import { convites as enUS_convites } from './en-US/convites';
import { erros as enUS_erros } from './en-US/erros';
import { escritas as enUS_escritas } from './en-US/escritas';
import { exportacao as enUS_exportacao } from './en-US/exportacao';
import { formulario as enUS_formulario } from './en-US/formulario';
import { identidade as enUS_identidade } from './en-US/identidade';
import { inicio as enUS_inicio } from './en-US/inicio';
import { participantes as enUS_participantes } from './en-US/participantes';
import { usuarios as enUS_usuarios } from './en-US/usuarios';
import { auth as esES_auth } from './es-ES/auth';
import { campanhas as esES_campanhas } from './es-ES/campanhas';
import { common as esES_common } from './es-ES/common';
import { convites as esES_convites } from './es-ES/convites';
import { erros as esES_erros } from './es-ES/erros';
import { escritas as esES_escritas } from './es-ES/escritas';
import { exportacao as esES_exportacao } from './es-ES/exportacao';
import { formulario as esES_formulario } from './es-ES/formulario';
import { identidade as esES_identidade } from './es-ES/identidade';
import { inicio as esES_inicio } from './es-ES/inicio';
import { participantes as esES_participantes } from './es-ES/participantes';
import { usuarios as esES_usuarios } from './es-ES/usuarios';
import { auth as ptBR_auth } from './pt-BR/auth';
import { campanhas as ptBR_campanhas } from './pt-BR/campanhas';
import { common as ptBR_common } from './pt-BR/common';
import { convites as ptBR_convites } from './pt-BR/convites';
import { erros as ptBR_erros } from './pt-BR/erros';
import { escritas as ptBR_escritas } from './pt-BR/escritas';
import { exportacao as ptBR_exportacao } from './pt-BR/exportacao';
import { formulario as ptBR_formulario } from './pt-BR/formulario';
import { identidade as ptBR_identidade } from './pt-BR/identidade';
import { inicio as ptBR_inicio } from './pt-BR/inicio';
import { participantes as ptBR_participantes } from './pt-BR/participantes';
import { usuarios as ptBR_usuarios } from './pt-BR/usuarios';

export const resources = {
  'pt-BR': {
    common: ptBR_common,
    auth: ptBR_auth,
    inicio: ptBR_inicio,
    campanhas: ptBR_campanhas,
    exportacao: ptBR_exportacao,
    formulario: ptBR_formulario,
    identidade: ptBR_identidade,
    participantes: ptBR_participantes,
    usuarios: ptBR_usuarios,
    escritas: ptBR_escritas,
    convites: ptBR_convites,
    erros: ptBR_erros,
  },
  'en-US': {
    common: enUS_common,
    auth: enUS_auth,
    inicio: enUS_inicio,
    campanhas: enUS_campanhas,
    exportacao: enUS_exportacao,
    formulario: enUS_formulario,
    identidade: enUS_identidade,
    participantes: enUS_participantes,
    usuarios: enUS_usuarios,
    escritas: enUS_escritas,
    convites: enUS_convites,
    erros: enUS_erros,
  },
  'es-ES': {
    common: esES_common,
    auth: esES_auth,
    inicio: esES_inicio,
    campanhas: esES_campanhas,
    exportacao: esES_exportacao,
    formulario: esES_formulario,
    identidade: esES_identidade,
    participantes: esES_participantes,
    usuarios: esES_usuarios,
    escritas: esES_escritas,
    convites: esES_convites,
    erros: esES_erros,
  },
} as const;

export const defaultNS = 'common' as const;
export const supportedLanguages = ['pt-BR', 'en-US', 'es-ES'] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];
